




































import { Component, Vue, Watch } from "vue-property-decorator";
import AdvertiserApi from "@/utils/api/advertiser";
import app from "@/store/app";

@Component
export default class RetailerList extends Vue {
  public select = "Commission Rate";
  public items = ["Commission Rate", "Advertiser Name"];
  public advertisers: Advertiser[] = [];
  public renderRow(index: number) {
    return index % 2 !== 0 ? "even-row" : "";
  }

  get queryParam() {
    switch (this.select) {
      case "Commission Rate":
        return 0;
      case "Advertiser Name":
        return 1;
      default:
        return 0;
    }
  }

  @Watch("select")
  public onSelectChange() {
    this.getData();
  }

  public mounted() {
    this.getData();
  }

  public async getData() {
    try {
      app.SET_IS_LOADING(true);
      const response = await AdvertiserApi.getAdvertiserList(this.queryParam);
      this.advertisers = response;

      app.SET_IS_LOADING(false);
    } catch (error) {
      Promise.reject(error);
    }
  }
}
